

import { unlink } from "node:fs/promises";
import path from "node:path";

const PRODUCT_UPLOADS_PREFIX = "/uploads/products/";

export function isLocalProductImage(imageUrl: string) {
  return imageUrl.startsWith(PRODUCT_UPLOADS_PREFIX);
}

export function getLocalProductImagePath(imageUrl: string) {
  if (!isLocalProductImage(imageUrl)) {
    return null;
  }

  const relativePath = imageUrl.replace(/^\/+/, "");
  return path.join(process.cwd(), "public", relativePath);
}

export async function deleteLocalProductImage(imageUrl: string) {
  const filePath = getLocalProductImagePath(imageUrl);

  if (!filePath) {
    return;
  }

  try {
    await unlink(filePath);
  } catch (error) {
    const err = error as NodeJS.ErrnoException;

    if (err.code === "ENOENT") {
      return;
    }

    throw error;
  }
}

export async function deleteLocalProductImages(imageUrls: string[]) {
  await Promise.all(imageUrls.map((imageUrl) => deleteLocalProductImage(imageUrl)));
}